import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WorkspacesPage } from '@/features/admin/workspaces/workspace-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Tous les espaces de travail du tenant (porting README #84). */
export const Route = createFileRoute('/$tenant/workspaces/')({ component: WorkspacesRoute });

function WorkspacesRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="jupyter" crumbs={[{ label: t('admin.workspaces.title') }]}>
      <WorkspacesPage tenantId={tenant} />
    </ConsoleShell>
  );
}
